import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useAuth } from "@src/presentation/hooks/auth/useAuth";
import { LoadingSpinner } from "@src/presentation/components/common";

/**
 * Public Route Component - Presentation layer
 * Single Responsibility: Redirects authenticated users away from public routes
 */
interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const auth = useAuth();

  if (auth.isLoading()) {
    return <LoadingSpinner />;
  }

  if (auth.isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
